import styled, { createGlobalStyle } from "styled-components";
import Modal from "react-modal";

export const SelectDropdownStyles = createGlobalStyle`
  .css-1dimb5e-singleValue {
    color: #444444 !important;
  }
  .css-1wa3eu0-placeholder {
    color: #444444a6 !important;
  }
`;

export const EventModalContainer = styled(Modal)`
  position: absolute;
  background-color: transparent;
  border: none;
  padding: 0;
  z-index: 999999;

  &:focus {
    outline: none;
  }
`;

export const EventModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "8px",
    transform: "translate(-50%, -50%)",
    padding: "0",
    border: "none",
    background: "transparent",
  },
  overlay: {
    zIndex: 999999,
    backgroundColor: "rgba(68, 68, 68, 0.8)"
  },
};

export const ModalContent = styled.div`
  width: 677px;
  height: auto;
  min-height: 242px;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalTitle = styled.h2`
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  font-style: bold;
  line-height: 22px;
  color: #1f2937;
  margin: 0 0 16px 0;
  text-align: left;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LabelText = styled.label`
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-style: SemiBold;
  line-height: 18.86px;
  color: #000000;
  margin-bottom: 4px;
  
  .required-asterisk {
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-style: SemiBold;
    line-height: 18.86px;
    color: #DC2626;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;
`;

export const CancelButton = styled.button`
  width: 106px;
  height: 34px;
  padding: 4px 16px;
  border: none;
  background: #E2E8F0;
  color: #002244;
  border-radius: 5px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  font-style: bold;
  line-height: 25.14px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover {
    background: #cbd5e1;
  }
  
  &:active {
    background: #94a3b8;
  }
`;

export const ContinueButton = styled.button`
  width: 118px;
  height: 34px;
  padding: 4px 16px;
  border: none;
  background: #002244;
  color: #FFFFFF;
  border-radius: 5px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  font-style: bold;
  line-height: 25.14px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover:not(:disabled) {
    background: #1a365d;
  }
  
  &:active:not(:disabled) {
    background: #2d3748;
  }
  
  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`;